import React from 'react';
import NotificationsSearchResults from './NotificationsSearchResults';
import SearchMenu, { FilterConsumer } from '../components/SearchMenu';
function NotificationsSearch() {
  return (
    <SearchMenu>
      <FilterConsumer>
        {(AgencyFilter) => <NotificationsSearchResults filter={AgencyFilter} />}
      </FilterConsumer>
    </SearchMenu>
  );
}

export default NotificationsSearch;
